import { render, staticRenderFns } from "./GenDetail.vue?vue&type=template&id=3728d68f&scoped=true"
import script from "./GenDetail.vue?vue&type=script&lang=js"
export * from "./GenDetail.vue?vue&type=script&lang=js"
import style0 from "./GenDetail.vue?vue&type=style&index=0&id=3728d68f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3728d68f",
  null
  
)

export default component.exports